function scrollToPosition(top: number) {
  window.scrollTo(0, top);
}

const scrollToProps: {
  bodyHeight: number | 'auto';
  pageYOffset: number;
} = {
  bodyHeight: 'auto',
  pageYOffset: 0,
};

const ScrollBackend = {
  invoke: {
    saveScrollPosition: () => {
      scrollToProps.pageYOffset = window.pageYOffset;
      scrollToProps.bodyHeight =
        window.pageYOffset === 0 ? 'auto' : document.body.offsetHeight;
    },
    scrollTop: () => {
      scrollToPosition(0);
    },
    restoreScrollPosition: () => {
      scrollToPosition(scrollToProps.pageYOffset);
    },
  },
};

export default ScrollBackend;
